import ResponsiveContainer from './responsiveContainer.component';

export default ResponsiveContainer;